import { useQuery } from '@tanstack/react-query';
import { fetchDashboardContentData } from '../services/dashboardContentService';

export function useDashboardContentData(options = {}) {
  return useQuery({
    queryKey: ['dashboardContentData'],
    queryFn: fetchDashboardContentData,
    staleTime: 3 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    retry: 2,
    refetchOnMount: options.refetchOnMount ?? true,
    refetchOnWindowFocus: false,
    refetchOnReconnect: true,
    placeholderData: {
      quiz: { current: [], past: [], upcoming: [] },
      pyp: { current: [], past: [], upcoming: [] },
      test_series: { current: [], past: [], upcoming: [] },
    },
  });
}
